import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownList, DropdownListItem, DropdownWrapper } from './dropdown.style';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const DropDownComponent = ({
    isOpen = false,
    close = () => { },
    actions = [
        { label: 'Menu 1', action: () => console.log('menu 1 clicked') },
        { label: 'Menu 2', action: () => console.log('menu 2 clicked') },
        { label: 'Menu 3', action: () => console.log('menu 3 clicked') },
    ],
    mui = false,
    anchorEl,
}) => {
    const wrapperRef = useRef(null);
    const [openUpward, setOpenUpward] = useState(false);

    useEffect(() => {
        if (isOpen && wrapperRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const dropdownHeight = rect.height || 120;
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
                setOpenUpward(true);
            } else {
                setOpenUpward(false);
            }
        }
    }, [isOpen]);

    const handleClick = (action) => {
        if (typeof action === 'function') action();
        close();
    };

    return (
        <>
            {
                mui ? (
                    <Menu
                        anchorEl={anchorEl}
                        open={isOpen}
                        onClose={close}
                        sx={{ my: '10px' }}
                    >
                        {
                            actions && actions.length > 0 && actions.map((action, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={() => handleClick(action.action)}
                                    sx={{
                                        '&.Mui-focusVisible': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {action.label}
                                </MenuItem>
                            ))
                        }
                    </Menu>
                ) : (
                    <DropdownWrapper
                        $isOpen={isOpen}
                        className={`box-shadow${openUpward ? ' dropdown-upward' : ''}`}
                        ref={wrapperRef}
                    >
                        <DropdownList>
                            {
                                actions && actions.length > 0 && actions.map((action, index) => (
                                    <DropdownListItem key={index} onClick={() => handleClick(action.action)}>
                                        {action.label}
                                    </DropdownListItem>
                                ))
                            }
                        </DropdownList>
                    </DropdownWrapper>
                )
            }
        </>
    );
};

DropDownComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    actions: PropTypes.array.isRequired,
    mui: PropTypes.bool,
};

export default DropDownComponent;
